import classNames from 'classnames';
import styles from './styles.module.scss';

const Suggestion = (props) => {
  const { className, getSuggestionItemProps, suggestion, formatStateSuggestion = false } = props;

  return (
    <div
      {...getSuggestionItemProps(suggestion, {
        className: classNames(styles.suggestion, { [styles.active]: suggestion.active }, className),
      })}
    >
      <div className={styles.description}>
        {(suggestion?.Type === 'District'
          ? `${suggestion?.Name?.replace(' School District', '')}${
              suggestion?.City ? ', ' + suggestion?.City : ''
            } ${suggestion?.State ? ', ' + suggestion?.State : ''} ${
              suggestion?.PostalCode ? ', ' + suggestion?.PostalCode : ''
            }`
          : suggestion?.FullAddress
          ? suggestion.FullAddress
          : suggestion.street_line
          ? `${suggestion.street_line}${suggestion.secondary ? ' ' + suggestion.secondary : ''}, ${
              suggestion.city
            }, ${suggestion.state} ${suggestion.zipcode}`
          : formatStateSuggestion
          ? suggestion?.formattedSuggestion?.mainText
          : suggestion.description
        )?.replace(', USA', '')}
      </div>
    </div>
  );
};

export default Suggestion;
